export const isUserLoggedIn = () => {
  const token = localStorage.getItem("authToken");
  return !!token;
};

export const userId = localStorage.getItem("loggedUserId") || null;
export const shouldHideInfo = userId !== "1";

// Local development API
// export const API_URL = "http://localhost/Quest-Manual/api-well-known/public/api";

// Live API
export const API_URL = "https://surveys.exchange-ip.com/api";
